import * as React from "react";
import {
  IXGUIFieldBase,
  TOnChange,
} from "../../../utils/interfaces/gui/fields.interfaces";
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

import { Divider, Fab, Stack, TextField, Typography } from "@mui/material";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

const compareProps = (prevProps: any, nextProps: any) => {
  return prevProps.currentValue === nextProps.currentValue;
};
interface XGUIColorFieldProps extends IXGUIFieldBase {
  onChange: TOnChange<string>;
  currentValue: string;
}

const XGUIColorField: React.FC<XGUIColorFieldProps> = React.memo(
  ({ field, currentValue, onChange }) => {
    const bp = useBreakpoint();
    const [open, setOpen] = React.useState<boolean>(false);

    const id = `XGUI-FIELD-${field.name}`;

    const color = currentValue ?? field.defaultValue;

    return (
      <React.Fragment>
        {open && (
          <Stack
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            zIndex={1050}
            onClick={() => setOpen(false)}
          />
        )}
        <Stack
          className="XGUIColorPicker"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          position="relative"
        >
          <Typography component="label" htmlFor={id} width="40%">
            {field.label}
          </Typography>
          <Stack width="100%" direction="row" spacing={1} ml={1}>
            <Stack
              sx={{
                backgroundImage: 'url("/images/transparent.png")',
                backgroundPosition: "center",
                backgroundSize: "cover",
                borderRadius: "50%",
                position: "relative",
              }}
            >
              <Fab
                aria-describedby={`XGUIColorPicker-Popover-${field.name}`}
                onClick={() => setOpen((old) => !old)}
                id={`XGUIColorPicker-Btn-${field.name}`}
                size="small"
                color="inherit"
                sx={{
                  width: 30,
                  height: 30,
                  position: "relative",
                }}
                style={{ backgroundColor: color }}
              />
              {open && (
                <Stack
                  sx={{
                    bgcolor: "white",
                    p: 1,
                    borderRadius: 2,
                    position: "absolute",
                    top: 40,
                    left: 0,
                    zIndex: 1051,
                  }}
                >
                  <HexAlphaColorPicker
                    color={color}
                    onChange={(newColor) => {
                      console.log("COLOR =>", newColor);
                      onChange(newColor, field.name, bp);
                    }}
                  />
                </Stack>
              )}
            </Stack>

            <TextField
              id={id}
              sx={{ flex: 1 }}
              hiddenLabel
              size="small"
              placeholder={field.placeholder}
              value={color}
              InputProps={{
                inputComponent: HexInput,
                inputProps: {
                  placeholder: "#FFFFFF",
                  color: color,
                  onChange: (newColor: any) => {
                    onChange(newColor, field.name, bp);
                  },
                  alpha: true,
                  prefixed: true,
                },
              }}
            />
          </Stack>
        </Stack>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 1 }} />
      </React.Fragment>
    );
  },
  compareProps
);

export default XGUIColorField;

const HexInput = React.forwardRef((props, ref) => {
  React.useImperativeHandle(ref, () => ({
    focus: () => {},
  }));

  return <HexColorInput {...props} />;
});
